import gql from "graphql-tag";

const TERMS_AND_CONDITION = gql`
query termsandcondition($locale: I18NLocaleCode, $identifier: String) {
    termsAndConditions(locale: $locale, filters: {
        identifier: {
            eq: $identifier
        }
    }) {
        data {
            attributes {
                identifier
                termsAndConditions
            }
        }
    }
}
`;

export default TERMS_AND_CONDITION;
